














import { Component, Prop, Vue } from 'vue-property-decorator';
import Car from '@/entities/Car';

@Component
export default class CarTile extends Vue {
  @Prop()
  car: Car;
}
